<template>
    <div class="rcornersgrey mx-auto vstack" style="max-width:800px; overflow: initial;">
        <h1 class="text-center">{{title}}</h1>
        <div class="container">
            <div class="callout callout-info">To recover your account, begin by entering your username and then click on the submit button.</div>                        
            <label for="txtRecoveryEmail">Username:*</label>
            <input type="text" id="txtRecoveryEmail" class="form-control" v-model="recoveryInfo" />
            <div id="buttonWrap" class="mt-4">
                <button class="btn btn-lg btn-primary" type="button" aria-label="submit button" @click.prevent="handleSubmitClick">Submit</button>
            </div>
            <div class="alert alert-info mt-1" role="alert" v-show="showAlert">
                {{ alertText }}
            </div>                
        </div>
    </div>
</template>
<script setup lang="ts">
import { computed, ref, watch, PropType } from 'vue';
import { useAuthStore } from '@/stores/authStore';

const props = defineProps<{
    title:string
}>()

const recoveryInfo = ref("");
const showAlert = ref(false);

const alertText = computed(()=> {
    return `Account recovery email sent to ${recoveryInfo.value}
If you don’t see this email in your inbox within 15 minutes, look for it in your junk mail folder. If you find it there, please mark it as “Not Junk”.`
});

const authStore = useAuthStore();

const emits = defineEmits([]);

function handleSubmitClick() {
    authStore.sendPasswordResetRequest(recoveryInfo.value);
    
    showAlert.value = true;
}
</script>